import { createAsyncThunk } from '@reduxjs/toolkit';

import Analytics from '@web-solutions/module-analytics';
import Attribution from '@web-solutions/module-attribution';

import { init as initRemoteConfig } from '@web-solutions/core/store/remote-config/actions';

import { applyTheme } from '@web-solutions/core/utils/theme';

import { setSteps } from '@web-solutions/core/upsale/store';

import { init as initRouting } from 'core/store/routing/actions';
import { auth } from 'core/store/profile/actions';

import { initLocalization } from 'core/localization';

import { APP_LINKS } from 'core/constants/general';
import { INITIAL_CONFIG } from 'core/constants/remote-config';

import { appSlice, type AppState } from '.';
import { setDevVisible } from 'core/utils/dev';

export const { setLoaded, setAppLink, setPending } = appSlice.actions;

export const initAppLink = createAsyncThunk(
  `${appSlice.name}/initAppLink`,
  //@ts-ignore
  async (data: any, { dispatch, getState }) => {
    const { appPlatform, webAppLink, appLinkParams } = (getState() as any).remoteConfig;

    const appLink = await Attribution.getLinkToApp(
      undefined,
      { appLinkParams, ...data },
      appPlatform,
      webAppLink
    );
    dispatch(setAppLink(appLink));
  }
);

export const downloadApp = createAsyncThunk(
  `${appSlice.name}/downloadApp`,
  async (_, { getState }) => {
    const state = getState();
    const { appPlatform } = (getState() as any).remoteConfig;
    const {
      app: { appLink },
    } = state as { app: AppState };

    Analytics.trackEvent(`install_${appPlatform === 'web' ? 'web' : 'app'}`, 'click');

    const link = document.createElement('a');
    link.href = appLink;
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
  }
);

export const load = () => async (dispatch: any, getState: any) => {
  try {
    dispatch(auth());

    await dispatch(initRemoteConfig(process.env.REACT_APP_MAGNUS_TOKEN!, INITIAL_CONFIG));

    const state = getState();

    const isShow1clickTestBtn = state?.remoteConfig?.isShow1clickTestBtn;
    setDevVisible(isShow1clickTestBtn)

    await initLocalization(dispatch, state);
    await dispatch(initRouting());

    Attribution.init(APP_LINKS);

    const theme = state?.remoteConfig?.theme;
    const upsaleFlow = state?.remoteConfig?.upsaleFlow;

    if (theme) {
      applyTheme(theme);
    }

    dispatch(initAppLink({}));
    dispatch(setSteps(upsaleFlow || []));
  } catch (error) {
    console.warn('[ERROR INIT APP]', error);
  } finally {
    dispatch(setLoaded(true));
  }
};
